/* Fills its positioned parent (the card's fixed-height imageBox), matching
   what expo-image's contentFit="cover" produced before. */
.img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
